var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-filter"},[_c('ul',{staticClass:"base-filter__list"},_vm._l((_vm.list),function(item){return _c('li',{key:item.value,staticClass:"base-filter__item",class:[
        {'is-active': item.value === _vm.value}
      ],on:{"click":function($event){return _vm.handleClick(item.value)}}},[_c('span',[_vm._v(_vm._s(item.label))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }